import { Module } from "vuex";
import { State } from "@/store/modules/catalog/state";
import Mutations from "@/store/modules/catalog/mutations";
import Getters from "@/store/modules/catalog/getters";
import Actions from "@/store/modules/catalog/actions";

export class Catalog implements Module<State, any> {
  namespaced: boolean = true;
  state: State;
  mutations = Mutations;
  getters = Getters;
  actions = Actions;

  // Setup CRUD operations
  constructor() {
    this.state = new State();
  }
}
